import { Check, Plus } from "lucide-react";
import { useEffect, useState } from "react";
import type { GarmentOrder, GarmentWithCount } from "../types";
import { GarmentSizeHistory } from "./GarmentSizeHistory";

type ProductCardProps = {
  garment: GarmentWithCount;
  previousOrders: GarmentOrder[];
  onAdd: (garmentName: string, size: string) => void;
};

export function ProductCard({ garment, previousOrders, onAdd }: ProductCardProps) {
  const [size, setSize] = useState(garment.defaultSize);
  const [justAdded, setJustAdded] = useState(false);

  useEffect(() => {
    if (!justAdded) return;
    const timer = window.setTimeout(() => setJustAdded(false), 1100);
    return () => window.clearTimeout(timer);
  }, [justAdded]);

  function handleAdd() {
    onAdd(garment.name, size);
    setJustAdded(true);
  }

  return (
    <article className="product-card">
      <div className="product-card__media">
        {garment.ordered > 0 && (
          <span className="order-badge">
            <strong>{garment.ordered}</strong> beställda
          </span>
        )}
        <img src={garment.imageUrl} alt={garment.name} loading="lazy" />
      </div>
      <div className="product-card__body">
        <div className="product-card__title">
          <div>
            <h3>{garment.name}</h3>
            <p>{garment.supplierName}</p>
          </div>
          <strong className="product-card__price">{garment.price} kr</strong>
        </div>
        <div className="product-card__actions">
          <label>
            <span className="sr-only">Storlek för {garment.name}</span>
            <select value={size} onChange={(event) => setSize(event.target.value)}>
              {garment.sizes.map((option) => <option key={option}>{option}</option>)}
            </select>
          </label>
          <button className={justAdded ? "add-button add-button--success" : "add-button"} type="button" onClick={handleAdd}>
            {justAdded ? <Check size={18} /> : <Plus size={18} />}
            {justAdded ? "Tillagd" : "Lägg till"}
          </button>
        </div>
        <GarmentSizeHistory garmentName={garment.name} orders={previousOrders} />
      </div>
    </article>
  );
}
